import * as React from "react";
import { IconProps } from "../types";

const CircleDottedIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="12"
        height="13"
        viewBox="0 0 12 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <g clipPath="url(#clip0_3215_9821)">
          <path
            d="M6 2C6.41421 2 6.75 1.66421 6.75 1.25C6.75 0.835786 6.41421 0.5 6 0.5C5.58579 0.5 5.25 0.835786 5.25 1.25C5.25 1.66421 5.58579 2 6 2Z"
            fill={color}
          />
          <path
            d="M3.375 2.70312C3.78921 2.70312 4.125 2.36734 4.125 1.95312C4.125 1.53891 3.78921 1.20312 3.375 1.20312C2.96079 1.20312 2.625 1.53891 2.625 1.95312C2.625 2.36734 2.96079 2.70312 3.375 2.70312Z"
            fill={color}
          />
          <path
            d="M1.453 4.625C1.86722 4.625 2.203 4.28921 2.203 3.875C2.203 3.46079 1.86722 3.125 1.453 3.125C1.03879 3.125 0.703003 3.46079 0.703003 3.875C0.703003 4.28921 1.03879 4.625 1.453 4.625Z"
            fill={color}
          />
          <path
            d="M0.75 7.25C1.16421 7.25 1.5 6.91421 1.5 6.5C1.5 6.08579 1.16421 5.75 0.75 5.75C0.335786 5.75 0 6.08579 0 6.5C0 6.91421 0.335786 7.25 0.75 7.25Z"
            fill={color}
          />
          <path
            d="M1.453 9.875C1.86722 9.875 2.203 9.53921 2.203 9.125C2.203 8.71079 1.86722 8.375 1.453 8.375C1.03879 8.375 0.703003 8.71079 0.703003 9.125C0.703003 9.53921 1.03879 9.875 1.453 9.875Z"
            fill={color}
          />
          <path
            d="M3.375 11.7969C3.78921 11.7969 4.125 11.4611 4.125 11.0469C4.125 10.6327 3.78921 10.2969 3.375 10.2969C2.96079 10.2969 2.625 10.6327 2.625 11.0469C2.625 11.4611 2.96079 11.7969 3.375 11.7969Z"
            fill={color}
          />
          <path
            d="M6 12.5C6.41421 12.5 6.75 12.1642 6.75 11.75C6.75 11.3358 6.41421 11 6 11C5.58579 11 5.25 11.3358 5.25 11.75C5.25 12.1642 5.58579 12.5 6 12.5Z"
            fill={color}
          />
          <path
            d="M8.625 11.7969C9.03921 11.7969 9.375 11.4611 9.375 11.0469C9.375 10.6327 9.03921 10.2969 8.625 10.2969C8.21079 10.2969 7.875 10.6327 7.875 11.0469C7.875 11.4611 8.21079 11.7969 8.625 11.7969Z"
            fill={color}
          />
          <path
            d="M10.547 9.875C10.9612 9.875 11.297 9.53921 11.297 9.125C11.297 8.71079 10.9612 8.375 10.547 8.375C10.1328 8.375 9.797 8.71079 9.797 9.125C9.797 9.53921 10.1328 9.875 10.547 9.875Z"
            fill={color}
          />
          <path
            d="M11.75 7.5C12.1642 7.5 12.5 7.16421 12.5 6.75C12.5 6.33579 12.1642 6 11.75 6C11.3358 6 11 6.33579 11 6.75C11 7.16421 11.3358 7.5 11.75 7.5Z"
            fill={color}
          />
          <path
            d="M10.547 4.625C10.9612 4.625 11.297 4.28921 11.297 3.875C11.297 3.46079 10.9612 3.125 10.547 3.125C10.1328 3.125 9.797 3.46079 9.797 3.875C9.797 4.28921 10.1328 4.625 10.547 4.625Z"
            fill={color}
          />
          <path
            d="M8.625 2.70312C9.03921 2.70312 9.375 2.36734 9.375 1.95312C9.375 1.53891 9.03921 1.20312 8.625 1.20312C8.21079 1.20312 7.875 1.53891 7.875 1.95312C7.875 2.36734 8.21079 2.70312 8.625 2.70312Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_3215_9821">
            <rect
              width="12"
              height="12"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  },
);

export default CircleDottedIcon;
